import React, { useEffect, useState } from 'react'
import ReactPaginate from 'react-paginate'
import { useAdminContext } from '../../../context/adminContext';
import { S3_URL } from '../../../utils/BaseUrl';
import { capitalizeWords, dateFormat } from '../../../utils/HelperFuncitons';
import LimitPagination from '../../common/LimitPagination';
import ImageViewModal from '../../common/Modal/ImageViewModal';
import CommonTable from '../../common/Table/CommonTable';
import { getAllRestaurantApi, getCuisinesListApi, getMenuItemCategoryApi, restaurantById, updateMenuItemDetailsApi, updatePartnerProfileApi, uploadFileApi } from '../../../utils/ApiEndpointFunctions';
import toast from 'react-hot-toast';
import { useFormik } from 'formik';
import { menuItemInitialValues, menuItemValidationSchema, profileDetailsInitialValue, profileValidationSchema } from '../../common/Validation';
import AddOrUpdateDetails from '../../common/Modal/AddOrUpdateDetails';

function RestaurantMenu({ id }) {
   const [loader, setLoader] = useState(false);
   const [details, setDetails] = useState([]);
   const [selectedPage, setSelectedPage] = useState(1);
   const [search, setSearch] = useState("");
   const [totalCount, setTotalCount] = useState(null);
   const [page, setPage] = useState(0);
   // const { limit } = useAdminContext();
   const imageViewModalId = "imageViewModalId"
   const [selectedImg, setSelectedImg] = useState("")
     const [activeTab, setActiveTab] = useState('driver');
     const [fileUpload,setFileUpload] = useState([])
     const [detailsType,setDetailsType] = useState({type:"",loading:false})
   const  [profileDetails, setProfiledetails] = useState({});
       const [vehicleDetails, setVehicleDetails] = useState([]);
       const [restaurantDetails, setRestaurantDetails] = useState({});
       const [restaurantDocument, setRestaurantDocument] = useState({});
       const [selectDocument, setSelectDocument] = useState({ status: "", keyName: "", validDate: "", restaurantId :""});
       const [bankDetails, setBankDetails] = useState([]);
       const [cuisinesList,setCusinesList]= useState([])
       const [categoryList,setCategoryList] = useState([])
        const driverBankModal2 = "driverBankModal2"
        const {limit, adminDetail} = useAdminContext();
   let currentPage = "";

     const searchFormik = useFormik({
       initialValues: {
         countryId: adminDetail.role !== "superAdmin" && adminDetail.countryId ? { label: adminDetail.countryName, value: adminDetail.countryId } : null,
         cityId: null,
       },
     })

   const handlePageClick = (event) => {
      currentPage = event.selected + 1;
      getAllRestaurantMenu(currentPage, limit)
      setSelectedPage(currentPage)
   };

   const getCuisinesList = async (limit,selectedPage)=>{
      try {
          const res = await getCuisinesListApi(limit, selectedPage, searchFormik.values.countryId?.value, searchFormik.values.cityId?.value )
         if (res.status === 200) {
            const data = res?.data?.cuisinesList;
           console.log("response hai kyaa", res.data.cuisinesList)
            setCusinesList(data)
         }
         setLoader(false);
       } catch (error) {
         setLoader(false);
         console.log(error);
       }
   }

   const getCategoryList = async (limit,selectedPage)=>{
      try {
           const res = await getMenuItemCategoryApi(limit, selectedPage, searchFormik.values.countryId?.value, searchFormik.values.cityId?.value)
           console.log("category list",res.data.data.list)
            const data = res?.data?.data?.list;
            setCategoryList(data)
            setLoader(false);
       } catch (error) {
         setLoader(false);
         console.log(error);
       }
   }

   // useEffect(()=>{
   //    categoryList.map((curElem)=>{
   //       console.log("elementttt",curElem.name)
   //    })
   //    },[categoryList])

   useEffect(()=>{
      getCuisinesList(limit,selectedPage)
      getCategoryList(limit,selectedPage)
   },[])

   async function handleFileUpload(name, e, formik) {
      try {
          const file = e.target.files[0];
          if (file) {
              const formData = new FormData();
              formData.append("file", file);
              formData.append("type", "documents")
              setFileUpload([...fileUpload, name])
              const res = await uploadFileApi(formData)
              formik.setFieldTouched(name, true)
              if (res.status === 200 && res.data?.status === 1) {
                  formik.setFieldValue(name, res.data?.data);
                  toast.success("File uploaded");
              }
          }
      } catch (error) {
          formik.setFieldTouched(`image`, true)
          console.log(error)
          if (error?.response === undefined) {
              toast.error("File size is too large")
          }
      }
      setFileUpload([...fileUpload?.filter(ele => ele != name)])
  }

  const fetchDriverDetails = async () => {
      try {
        const res = await restaurantById(id);
        if (res.status === 200) {
          const { vehicles, details } = res.data.data;
          const { id, role, phone, restaurant, restaurantDocument, bankDetails, partnerUserDetails } = details       
          setRestaurantDocument(restaurantDocument)
          setProfiledetails({ id, phone, role, ...partnerUserDetails[0], vendorStatus: restaurant.status });
          setVehicleDetails(vehicles);
          setRestaurantDetails(restaurant)
          setBankDetails(bankDetails)
         //  rateFormik.setValues({ id: id, deliveryFee: restaurant.deliveryFee, tax: restaurant.tax, discountOnOff: restaurant.discountOnOff, discount: restaurant.discount });
  
        }
        setLoader(false);
      } catch (error) {
        setLoader(false);
        console.log(error);
      }
    };

   async function getAllRestaurantMenu() {
      try {
         setLoader(true);
         const res = await getAllRestaurantApi(id, limit, currentPage, search, "", "");
         if (res.status === 200 || res.status === 201) {
            const data = res?.data?.data?.menuItemsList;
            const totalLength = res?.data?.data?.totalLength;
            setTotalCount(totalLength);
            setPage(Math.ceil(totalLength / limit));
            setDetails(data);
            setLoader(false);
         }
      } catch (error) {
         toast.error(error.message);
         setLoader(false);
      }
   }

   const headerData = [
      { name: "S.No", className: "col-1", key: "index" },
      { name: "Name", className: "col-1", key: "name" },
      { name: "Price", className: "col-1", key: "price" },
      { name: "Description", className: "col-1", key: "description" },
      { name: "Serving size", className: "col-1", key: "servingSize" },
      { name: "Category", className: "col-1", key: "menuItemCategory" },
      { name: "Cuisine", className: "col-1", key: "cuisine" },
      { name: "Status", className: "col-1", key: "isActive" },
      { name: "Created", className: "col-1", key: "createdAt" },
      { name: <div className='d-flex gap-2 justify-content-center align-items-center'>
      <div>Action</div>
      <div>
         <button 
            className='btn btn-primary' 
            data-bs-toggle="modal" 
            data-bs-target={`#driverBankModal2`}
            onClick={() => {
               // Reset form for create mode
               restaurantDetailsFormik?.resetForm();
               restaurantDetailsFormik?.setValues({
                  ...menuItemInitialValues,
                  menuItemCategory: null,
                  cuisine: null,
               });
               setActiveTab("menu");
               setDetailsType({...detailsType, type: "create"});
            }}
         >
            Add
         </button>
      </div>
   </div>, className: "col-1", key: "action" },
   ]

   const tableData = details?.map((item, index) => ({
      index: index + 1,
      name:
      (
         <>
            <div className="avatar avatar-xs align-middle me-2">
               <img
                  className="avatar-img rounded-circle"
                  src={!item.image ? "/images/profiledp.png" : `${S3_URL}/${item?.image}`}
                  alt="img"
                  data-bs-toggle="modal"
                  data-bs-target={`#${imageViewModalId}`}
                  style={{ cursor: 'pointer' }}
                  onClick={() => { setSelectedImg(!item.image ? "/images/profiledp.png" : `${S3_URL}/${item?.image}`) }}
               />
            </div>
            {item?.name ? capitalizeWords(`${item?.name}`) : "-"}
         </>)
         ,
      price: item?.price || "-",
      description: item?.description || "-",
      servingSize: item?.servingSize ? capitalizeWords(item?.servingSize) : "-",
      menuItemCategory: (
         <>
            <div className="avatar avatar-xs align-middle me-2">
               <img
                  className="avatar-img rounded-circle"
                  src={!item?.menuItemCategory?.image ? "/images/profiledp.png" : `${S3_URL}/${item?.menuItemCategory?.image}`}
                  alt="img"
                  data-bs-toggle="modal"
                  data-bs-target={`#${imageViewModalId}`}
                  style={{ cursor: 'pointer' }}
                  onClick={() => { setSelectedImg(!item?.menuItemCategory?.image ? "/images/profiledp.png" : `${S3_URL}/${item?.menuItemCategory?.image}`) }}
               />
            </div>
            {item?.menuItemCategory?.name ? capitalizeWords(`${item?.menuItemCategory?.name}`) : "-"}
         </>),
      cuisine: (
         <>
            <div className="avatar avatar-xs align-middle me-2">
               <img
                  className="avatar-img rounded-circle"
                  src={!item?.cuisine?.image ? "/images/profiledp.png" : `${S3_URL}/${item?.cuisine?.image}`}
                  alt="img"
                  data-bs-toggle="modal"
                  data-bs-target={`#${imageViewModalId}`}
                  style={{ cursor: 'pointer' }}
                  onClick={() => { setSelectedImg(!item?.cuisine?.image ? "/images/profiledp.png" : `${S3_URL}/${item?.cuisine?.image}`) }}
               />
            </div>
            {item?.cuisine?.name ? capitalizeWords(`${item?.cuisine?.name}`) : "-"}
         </>),
      createdAt: item?.createdAt ? dateFormat(item?.createdAt) : "-",
      isActive: item?.isActive ? "Enabled" : <div className='d-flex flex-column'><span>Disabled</span><span className='fs-5'>{item?.disableReason}</span></div>,
      action: (
         <span
           style={{ cursor: "pointer" }}
           data-bs-toggle="modal"
           data-bs-target={`#driverBankModal2`}
           onClick={() => {
            restaurantDetailsFormik?.setValues({
               ...item,
               name: item?.name,
               menuItemCategory: {
                 label: item?.menuItemCategory?.name || "-",
                 value: item?.menuItemCategory?._id || item?.menuItemCategory?.value || item?.menuItemCategory,
               },
               cuisine: {
                 label: item?.cuisine?.name || "-",
                 value: item?.cuisine?._id || item?.cuisine?.value || item?.cuisine,
               },
             });
             
             setActiveTab("menu");
             {console.log("item",item.name)}
           }}
         >
           Edit
         </span>
       ),
   }))

   const detailsFields = {
      "menu": {
        format: [
         //  { name: "index", label: "S.No", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
         { name: "name", label: "Name", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
         { name: "price", label: "Price", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
         { name: "description", label: "Description", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
         { name: "servingSize", label: "Serving size", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
         { name: "menuItemCategory", label: "Category", type: "select", options: categoryList?.map(ele => { return { label: ele?.name, value: ele?.name } }), handleOnChange: (...values) => handleInputChange(...values, "text") },
         { name: "cuisine", label: "Cuisine", type: "select", options: cuisinesList?.map(ele => { return { label: ele?.name, value: ele?.name } }), handleOnChange: (...values) => handleInputChange(...values, "text") },
         { name: "isActive", label: "Status", type: "toggle", handleOnChange: (...values) => handleInputChange(...values, "text") },
         { name: "createdAt", label: "Created", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
            // { name: "panImage", label: "File", type: "file", acceptFiles: "image/*", loading: fileUpload?.includes("File"), handleFileUpload },
        ],
        initialvalue: menuItemInitialValues,
        validationSchema: menuItemValidationSchema,
        handleSubmit: (values) => {
            console.log("Submitting values", values);
            console.log("consoleeeeeeeeeeeeeeeeee")
            handleDriverDetailSubmit({ ...values, gender: values?.gender?.value },
               updateMenuItemDetailsApi)},
        modalId: driverBankModal2
    },
      
  }

   const restaurantDetailsFormik = useFormik({
            initialValue:detailsFields?.[activeTab]?.initialvalue,
            validationSchema:detailsFields?.[activeTab]?.validationSchema,
            enableReinitialize:true,
            onSubmit:detailsFields?.[activeTab]?.handleSubmit
        })

        function handleInputChange(name, e, formik, input, type) {
           if (input == "input") {
              const { value } = e?.target
              if (type == "number" && isNaN(value)) return
              formik.setFieldValue(name, value)
           } else if (input == "date") {
              formik.setFieldValue(name, e)
           } else if (input == "select") {
              let list = [{ name, value: e }]
              if (name == "categoryId") {
                 list.push({ name: "modelId", value: "" }, { name: "makeId", value: "" })
              } else if (name == "modelId") {
                 list.push({ name: "makeId", value: "" })
              }

             list?.forEach(ele => {
                 formik.setFieldValue(ele?.name, ele?.value)
             })
         } else if (input == "address") {
             formik.setFieldValue(name, e?.label)
         } else if (input == "toggle") {
                 formik.setFieldValue(name, e)  
              }
     
     }

 

     async function handleDriverDetailSubmit(payload, apiEndPoint) {
      try {
          console.log("in try block")
          setDetailsType({ ...detailsType, loading: true })
          const res = await apiEndPoint({ ...payload, partnerUserId: id })
          if (res?.status == 200 || res?.status == 201) {
            getAllRestaurantMenu();
              document.getElementById(detailsFields[activeTab]?.modalId)?.click()
          }
      } catch (error) {
          toast.error(error?.response?.data?.message || "Something Went Wrong")
      }
      setDetailsType({ ...detailsType, loading: false })
    }

 



   //  const MenuData = [
   //     { name: "S.No", data: details.name, },
   //     { name: "Name", data: profileDetails.phone, },
   //     { name: "Price", data: profileDetails.alternateMobile, },
   //     { name: "Description", data: profileDetails.NIN, },
   //     { name: "Serving size", data: capitalizeWords(profileDetails.vendorStatus), },
   //     { name: "Category", data: profileDetails.role?.map(el => capitalizeWords(el))?.join(", "), },
   //     { name: "Cuisine", data: profileDetails.gender, },
   //     { name: "Status", data: profileDetails.city, },
   //     { name: "State", data: profileDetails.state, },
   //     { name: "Created", data: profileDetails.country, },
   //     { name: "Action", data: profileDetails.zip, }
   
   //   ]

 

   useEffect(() => {
      getAllRestaurantMenu()
   }, [])

   console.log("limit", limit);


   return (
      <>
         <div className="d-flex justify-content-end flex-wrap align-items-center mt-3 mt-lg-0">
            <LimitPagination getData={getAllRestaurantMenu} />
         </div>
         <CommonTable headers={headerData} data={tableData} loading={loader} />
         <ImageViewModal imgUrl={selectedImg} modalId={imageViewModalId} />

         {totalCount > limit ? (
            <div className="d-flex justify-content-center">
               <ReactPaginate
                  nextLabel="Next >"
                  onPageChange={handlePageClick}
                  pageRangeDisplayed={3}
                  marginPagesDisplayed={1}
                  pageCount={page}
                  previousLabel="< Previous"
                  pageClassName="page-item"
                  pageLinkClassName="page-link"
                  previousClassName="page-item"
                  previousLinkClassName="page-link"
                  nextClassName="page-item"
                  nextLinkClassName="page-link"
                  breakLabel="..."
                  breakClassName="page-item"
                  breakLinkClassName="page-link"
                  containerClassName="pagination"
                  activeClassName={"active"}
                  forcePage={selectedPage - 1}
               />
            </div>
         ) : (
            ""
         )}
         
         <AddOrUpdateDetails formik={restaurantDetailsFormik} dataFormat={detailsFields[activeTab]?.format} detailsFor={'Menu'} addLoader={detailsType?.loading} modalId={driverBankModal2} />
      </>
   )
}

export default RestaurantMenu